/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CopyAutoTestDataParser = /* #__PURE__ */ parsers.object([
    ['assignmentId', codecNumber, 'assignment_id'],
]);
export class CopyAutoTestData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CopyAutoTestDataParser.decode(input).map(res => new CopyAutoTestData(res));
    }
    static unsafeDecode(input) {
        return CopyAutoTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CopyAutoTestDataParser.encode(data);
    }
    static schema() {
        return CopyAutoTestDataParser.schema();
    }
}
